module.exports = __webpack_public_path__ + "static/media/alstonsystems.d2407e32.png";